import Vue from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

Vue.component('news-sidebar', {

    data() {
        return {
        };
    },

    mounted() {
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if (viewportWidth >= 1024) {
            this.initSidebar();
        }
    },

    methods: {
        initSidebar() {
            ScrollTrigger.create({
                trigger: '.newsitem__content-container',
                pin: '.newsitem__info',
                start: 'top top+=100px',
                end: self => "+=" + (document.querySelector(".newsitem__content-container").offsetHeight - self.pin.offsetHeight),
                pinSpacing: false
            });
        },
    },
});